// Whitespace only: members and form fills are also searched by email, lead id and phone, so
// digits and symbols (`@ . + - _`, apostrophes in names) must reach the backend untouched.
const normalizeSearchTerm = (term: string) => term.replace(/\s+/g, ' ').trim();

export default normalizeSearchTerm;
